import { Container, Row, Col, Button } from '@leroy-merlin-br/backyard-react-ui'

import { Accordion } from '../../components/Accordion'
import { data as FAQDATA } from './data'
import * as S from './styled'

const Section = () => (
  <S.Section>
    <Container>
      <Col size={{ giga: 10 }} offset={{ giga: 1 }}>
        <S.SectionTitle size="tera" noMargin>
          Ficou com alguma dúvida? A gente responde.
        </S.SectionTitle>

        <S.SectionText size="mega" noMargin>
          Você pode consultar nossa sessão de perguntas frequentes, ligar na{' '}
          <a
            href="https://www.leroymerlin.com.br/fale-conosco"
            target="_blank"
            rel="noopener noreferrer"
          >
            Central de Atedimento
          </a>{' '}
          ou até{' '}
          <a
            href="https://www.leroymerlin.com.br/fale-conosco"
            target="_blank"
            rel="noopener noreferrer"
          >
            Perguntar pra Lia
          </a>
          , nossa assitente virtual.
        </S.SectionText>

        <S.Faq>
          {FAQDATA.map(({ title, text }, index) => (
            <Accordion
              title={title}
              text={text}
              counter={index + 1}
              key={title}
            />
          ))}
        </S.Faq>

        <Container>
          <Row justify="center">
            <Button as="a" href="/fidelidade/participar" size="mega">
              Faça parte
            </Button>
          </Row>
        </Container>
      </Col>
    </Container>
  </S.Section>
)

export default Section
